import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import { SliderCSSVars, SliderDefinition, SliderProps } from '../Slider.types';
import {
  SliderTickMarksShape,
  SliderTickMarksPosition,
  SliderThumbShape,
} from '../documentManagement/Slider.schemaTypes';
import { Sizes } from '../constants';

export const props = withCompInfo<SliderProps, SliderDefinition>()(
  ['compData', 'compProps', 'compLayout', 'isMobileView'],
  ({ compData, compProps, compLayout, isMobileView }) => {
    const { min, max, value, step, stepType, readOnly } = compData;
    const {
      isDisabled,
      thumbShape,
      tickMarksShape,
      tickMarksPosition,
      tooltipPosition,
      tooltipVisibility,
      tooltipPrefix,
      tooltipSuffix,
      dir,
    } = compProps;
    // TODO: support responsive layout
    const width = compLayout.width || 0;
    const height = compLayout.height || 0;

    return {
      width,
      height,
      min,
      max,
      value,
      step,
      stepType,
      isDisabled,
      readOnly,
      thumbShape,
      tickMarksShape,
      tickMarksPosition,
      tooltipPosition: isMobileView ? 'normal' : tooltipPosition,
      tooltipVisibility,
      tooltipPrefix,
      tooltipSuffix,
      dir,
    };
  },
);

const getTicksCssByShape = (tickMarksShape: SliderTickMarksShape) => {
  if (tickMarksShape === 'line') {
    return {
      '--tickWidth': `${Sizes.tickLineWidth}px`,
      '--tickHeight': `${Sizes.tickLineHeight}px`,
    };
  }
  return {
    '--tickWidth': `${Sizes.tickDotSize}px`,
    '--tickHeight': `${Sizes.tickDotSize}px`,
    '--tickBorderRadius': '50%',
  };
};

const getTicksCssByPosition = (tickMarksPosition: SliderTickMarksPosition) => {
  return {
    normal: { '--tickBottom': '0' },
    middle: { '--tickTop': '50%', '--tickTranslateY': '-50%' },
    across: { '--tickTop': '0' },
  }[tickMarksPosition];
};

const getThumbBorderRadius = (
  styleProperties: Record<string, string>,
  thumbShape: SliderThumbShape,
) => {
  if (thumbShape === 'circle') {
    return '50%';
  }
  const defaultBorderRadiusByShape = {
    circle: '50%',
    square: '17px',
    rectangle: '37px',
    bar: '5px',
  };
  return (
    styleProperties.thumbBorderRadius || defaultBorderRadiusByShape[thumbShape]
  );
};

export const css = withCompInfo<SliderCSSVars, SliderDefinition>()(
  ['compProps', 'styleProperties'],
  ({ compProps, styleProperties }) => {
    const { trackSize, thumbShape, tickMarksPosition, tickMarksShape } =
      compProps;

    return {
      '--trackHeight': `${trackSize}%`,
      '--thumbBorderRadius': getThumbBorderRadius(styleProperties, thumbShape),
      ...getTicksCssByPosition(tickMarksPosition),
      ...(tickMarksShape !== 'none' && getTicksCssByShape(tickMarksShape)),
    };
  },
);

export default createComponentMapperModel({ css, props });
